import styled from 'styled-components';

export const StyledMeetingPage = styled.div`
    padding: 100px 10px;

    p {
        padding-left: 20px;
    }
`